const ModalHeader = props => {
  const { children, style } = props;

  return (
    <div className="r-modal__header" style={style}>
      {children}
    </div>
  );
};

export default ModalHeader;
